import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./escalaLiteral.css";
import Alert from "../../modal/alert";

class escalaLiteral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      escala: "",
      descripcion: "",
      codigoM: "",
      iescalas: [],
      listaOn: false,
      modificarOn: false,

      verplanillaOn: false,
    };
  }

  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  consultar(e) {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("boton", "Consultar");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/boletinMaternales.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data) {
            this.setState({
              //   codigo: res.data.variable1,
              //   cedula: res.data.variable2,
              //   nombre: res.data.variable3,
              //   motivo: res.data.variable4,
              //   ordendellegada: res.data.variable5,
            });
          }
        });
    }
  }

  guardar = () => {
    if (this.state.escala.length > 0 && this.state.descripcion.length > 0) {
      let data = new FormData();
      data.append("escala", this.state.escala);
      data.append("descripcion", this.state.descripcion);
      data.append("boton", "guardarEL");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/boletinMaternales.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.buscarEscala();
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Crear Tipos de Escalas",
              cuerpoM: res.data.variable2,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Crear Tipos de Escalas",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Crear Tipos de Escalas",
        cuerpoM: "Debe indicar el tipo de Escala y la Descripción, Verifique",
      });
    }
  };

  limpiar = () => {
    this.setState({
      codigoM: "",
      escala: "",
      descripcion: "",
      listaOn: false,
      modificarOn: false,
    });
  };

  modificar = () => {
    let data = new FormData();
    data.append("codigoM", this.state.codigoM);
    data.append("escala", this.state.escala);
    data.append("descripcion", this.state.descripcion);
    data.append("boton", "modificarMateria");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          this.buscarEscala();
          this.limpiar();
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Tipos de Escalas",
            cuerpoM: res.data.variable2,
          });
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Tipos de Escalas",
            cuerpoM: res.data.variable2,
          });
        }
      });
  };

  modificarSeleccion = (e, f, g) => {
    this.setState({
      codigoM: e,
      escala: f,
      descripcion: g,
      modificarOn: true,
    });
  };

  eliminar = (e) => {
    console.log(e);
    if (parseFloat(e) > 0) {
      let data = new FormData();

      data.append("idescala", e);
      data.append("boton", "eliminarEL");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/boletinMaternales.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Tipos de Escalas.",
            cuerpoM: res.data.variable2,
          });
          this.buscarEscala();
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Tipos de Escalas.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Tipos de Escalas.",
        cuerpoM: "Debe existir un registro para poder eliminar.",
      });
    }
  };

  buscarEscala = () => {
    let data = new FormData();
    data.append("boton", "buscarEscala");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xiescalas = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            iescalas: xiescalas,
          });
        } else {
          this.setState({
            iescalas: [],
          });
        }
      });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  componentDidMount() {
    this.buscarEscala();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>TIPOS DE ESCALAS PARA EVALUAR. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="contenedorp row">
            <div className="titulo-reprecxc col-12">
              <div className="contenedorcedula1 col-3">
                <input
                  className="form-control"
                  type="text"
                  name="escala"
                  id="escala"
                  autoComplete="off"
                  placeholder="Escala"
                  maxLength="3"
                  onChange={this.onChange.bind(this)}
                  value={this.state.escala.toUpperCase()}
                />
              </div>
              <div className="contenedorcedula1 col-9">
                <input
                  className="form-control"
                  type="text"
                  name="descripcion"
                  id="descripcion"
                  autoComplete="off"
                  placeholder="Descripcion de la Escala"
                  maxLength="100"
                  onChange={this.onChange.bind(this)}
                  value={this.state.descripcion.toUpperCase()}
                />
              </div>
            </div>
            <div className="xcontenedorcedula1x col-12">
              {!this.state.modificarOn && (
                <button className="boton" onClick={this.guardar.bind(this)}>
                  Agregar
                </button>
              )}
              {this.state.modificarOn && (
                <button className="boton" onClick={this.modificar.bind(this)}>
                  Modificar
                </button>
              )}
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc2">DESCRIPCION</th>
                    <th className="titucxc1">ESCALA</th>
                    <th className="titucxc3x">
                      <span className="titulo-eliminar">
                        <span className="cerrarme5"></span>
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.iescalas.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      <td className="totalescxcx">{item.variable3}</td>
                      <td className="xcerr">
                        {/* <span
                          className="cerrarme4m"
                          onClick={this.modificarSeleccion.bind(
                            this,
                            item.variable1,
                            item.variable2,
                            item.variable4
                          )}
                        ></span>{" "} */}
                        <span
                          className="cerrarme1"
                          onClick={this.eliminar.bind(this, item.variable1)}
                        ></span>{" "}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default escalaLiteral;
